<template>
	<ActiveAccounts
		:accounts="accounts"
		@another-account="goToSignIn"
		@refresh="refreshAccounts"
	>
		<template #launcher="{ account }">
			<Button pronto :href="`${account.origin}?invite=${invite.code}`">
				{{ $t('onboarding_accountpicker_launch') }}
			</Button>
		</template>
		<template #header>
			<div class="accounts-header">
				<h1 v-t="'groupinvites_title_singular'" />
				<ProfilePic :user="invite.organization" size="100px" />
				<p>
					<i18n-t keypath="groupinvites_signup_multiple_org_accounts">
						<template #OrgName>
							<strong v-text="invite.organization.name" />
						</template>
					</i18n-t>
				</p>
			</div>
		</template>
	</ActiveAccounts>
</template>

<script>
import ActiveAccounts from '@/components/Login/ActiveAccounts'
import { Button, ProfilePic } from '@/components/common'
import { getInvite, signinRoute } from './index'
import store from '@/store'

export default {
	name: 'InviteActiveAccounts',
	components: { ActiveAccounts, Button, ProfilePic },
	data() {
		const invite = getInvite()
		const accountsForOrg = store
			.getActiveUsers()
			.filter((a) => a.organization.id === invite.organization.id)
		return { invite, accounts: accountsForOrg }
	},
	methods: {
		refreshAccounts() {
			this.accounts = store
				.getActiveUsers()
				.filter((a) => a.organization.id === invite.organization.id)
		},
		goToSignIn() {
			this.$router.push({
				name: signinRoute.name,
				params: this.$route.params,
			})
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.accounts-header {
	@include flex-column-center;
	> h1 {
		font-size: 28px;
		margin-bottom: 50px;
	}
	> p {
		@include fontFamily(400);
		margin-bottom: 50px;
		text-align: center;
		:deep(strong) {
			@include fontFamily(800);
		}
	}
}
</style>
